module.exports = __webpack_public_path__ + "static/media/faq-lg.17886937.jpg";